import { render, staticRenderFns } from "./AppSessionsIndexComponent.vue?vue&type=template&id=d0c6974e"
import script from "./AppSessionsIndexComponent.vue?vue&type=script&lang=js"
export * from "./AppSessionsIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports